
import { useTestDetails } from "./test-creator/useTestDetails";
import { useTestQuestions } from "./test-creator/useTestQuestions";
import { useTestSave } from "./test-creator/useTestSave";
import type { TestDetails } from "./test-creator/useTestDetails";
import type { Question } from "@/types/test";

export const useTestCreator = (initialDetails?: Partial<TestDetails> | null, initialQuestions?: Question[]) => {
  console.log('🚀 useTestCreator initialized with:', initialDetails, 'Initial questions:', initialQuestions?.length);
  
  const {
    testDetails,
    setTestDetails,
  } = useTestDetails(initialDetails || undefined);

  const {
    questions,
    setQuestions,
    addQuestion,
    updateQuestion,
    deleteQuestion,
    addMultipleQuestions,
  } = useTestQuestions(initialQuestions || []);

  const { saveTest: save } = useTestSave(null);

  const handleSaveTest = async (details: TestDetails, questions: any[], publish: boolean = false) => {
    console.log("Saving test with publish =", publish);
    console.log("Final details for saving:", details);
    
    // Ensure all required fields have values
    const completeDetails = {
      ...details,
      // Add defaults for required fields
      title: details.title || 'Untitled Test',
      description: details.description || 'No description provided',
      location: details.location || 'Remote',
      salaryCurrency: details.salaryCurrency || 'INR',
      workArrangement: details.workArrangement || 'Full-Time',
      keySkills: Array.isArray(details.keySkills) ? details.keySkills : ['General'],
      industry: details.industry || null,
      seniority: details.seniority || null,
      welcomeMessage: details.welcomeMessage || null,
      completionMessage: details.completionMessage || null
    };
    
    // Set default markscheme values for questions if not present
    const processedQuestions = questions.map(question => {
      if (!question.markscheme) {
        // Create a default markscheme based on the question type and marks
        return {
          ...question,
          markscheme: {
            criteria: [
              {
                name: "Overall Assessment",
                description: "Overall assessment of the candidate's response",
                max_points: question.marks || 1
              }
            ],
            total_points: question.marks || 1,
            overall_guidance: "Evaluate based on technical accuracy and completeness of the response."
          }
        };
      }
      return question;
    });
    
    const result = await save(completeDetails, processedQuestions, publish);
    console.log("Test saved result:", result);
    return result;
  };

  return {
    testDetails,
    setTestDetails,
    questions,
    setQuestions,
    addQuestion,
    updateQuestion,
    deleteQuestion,
    addMultipleQuestions,
    saveTest: handleSaveTest,
  };
};

export type { TestDetails };
